/// <reference path="../_references.ts"/>

module App.TemplateStore {
	import Department = App.Appointments.Department;
	import SearchParams = App.PriceGuide.SearchParams;

	export class TemplateStoreService {
		constructor(
			private $http: ng.IHttpService,
			public Constants: IConstants
		) {

		}

		getTemplateDetails(templateId: number): ng.IHttpPromise<TemplateDetails> {
			return this.$http.get(`${this.Constants.apiUrl}storetemplate/${templateId}`);
		}

		getDownloadedTemplateDetails(templateId: number, params: {[key: string]: any} = {}, headers: {[key: string]: any} = {}): ng.IHttpPromise<TemplateDetails> {
			return this.$http.get(`${this.Constants.apiUrl}template/${templateId}`, {
				headers: headers,
				params: params
			});
		}

		getTemplateList(params: SearchParams): ng.IHttpPromise<StoreTemplate[]> {
			return this.$http.get(`${this.Constants.apiUrl}storetemplate`, {
				params: params
			});
		}

		favoriteTemplate(templateId: number): ng.IHttpPromise<TemplateDetails> {
			return this.$http.post(`${this.Constants.apiUrl}storetemplate/${templateId}/favorite`, {});
		}

		unfavoriteTemplate(templateId: number): ng.IHttpPromise<TemplateDetails> {
			return this.$http.post(`${this.Constants.apiUrl}storetemplate/${templateId}/unfavorite`, {});
		}

		downloadTemplate(storeTemplateId: number, downloadOptions: DownloadTemplateOptions): ng.IHttpPromise<TemplateDetails> {
			return this.$http.post(`${this.Constants.apiUrl}storetemplate/${storeTemplateId}/load`, downloadOptions);
		}

		rateTemplate(storeTemplateId: number, rating: number): ng.IHttpPromise<TemplateDetails> {
			return this.$http.post(`${this.Constants.apiUrl}storetemplate/${storeTemplateId}/rate`, { rating: rating })
		}

		getDepartments(): ng.IHttpPromise<Department[]> {
			return this.$http.get(`${this.Constants.apiUrl}department`);
		}

		public static Factory() {
			let instance = ($http: ng.IHttpService, Constants: IConstants) => {
				return new TemplateStoreService($http, Constants);
			};

			instance.$inject = ['$http', 'Constants'];

			return instance;
		}
	}
}